<template>
    <form>
        <div class="row q-col-gutter-md">
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="CountryObj.name"
                    :label="$t('countries.table_titles.name')"
                    lazy-rules
                    :error="CountryObj.errors.has('name')"
                    :error-message="CountryObj.errors.get('name')"
                    :rules="[ val => val && val.length > 0 || 'The Country name is required!']"
                    color="primary"
                />
            </div> <!-- NAME -->
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="CountryObj.acronym"
                    :label="$t('countries.table_titles.acronym')"
                    lazy-rules
                    :error="CountryObj.errors.has('acronym')"
                    :error-message="CountryObj.errors.get('acronym')"
                    :rules="[ val => val && val.length > 0 || 'The Country acronym is required!']"
                    color="primary"
                    maxlength="2"
                />
            </div> <!-- ACRONYM -->
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="CountryObj.acronym3"
                    :label="$t('countries.table_titles.acronym3')"
                    lazy-rules
                    :error="CountryObj.errors.has('acronym3')"
                    :error-message="CountryObj.errors.get('acronym3')"
                    :rules="[ val => val && val.length > 0 || 'The Country three letters acronym is required!']"
                    color="primary"
                    maxlength="3"
                />
            </div> <!-- ACRONYM3 -->
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="CountryObj.calling_code"
                    :label="$t('countries.table_titles.calling_code')"
                    :error="CountryObj.errors.has('calling_code')"
                    :error-message="CountryObj.errors.get('calling_code')"
                    hint="Exp: 64, 84, 90, etc"
                    color="primary"
                >
                    <template v-slot:prepend>
                        <q-icon name="fa fa-plus" />
                    </template>
                </q-input>
            </div> <!-- CALLING CODE -->
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-select
                    v-model="CountryObj.currency_acronym"
                    :options="currencies"
                    :label="$t('countries.table_titles.currency')"
                    stack-label
                    map-options
                    emit-value
                    clearable
                    option-value="acronym"
                    option-label="name"
                    :loading="exchange_rates_loading"
                    color="primary"
                >
                    <template v-slot:option="scope">
                        <q-item
                            v-bind="scope.itemProps"
                            v-on="scope.itemEvents"
                            style="border-bottom:1px solid #999"
                        >
                            <q-item-section>
                                <q-item-label lines="1">
                                    <span class="text-weight-medium text-uppercase">({{scope.opt.acronym}}) - </span>
                                    <span class="text-bold">{{scope.opt.name}}</span>
                                </q-item-label>
                            </q-item-section>
                        </q-item>
                    </template>
                </q-select>
            </div> <!-- CURRENCY -->
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="CountryObj.reward_amount_of_new_user"
                    type="Number"
                    :label="$t('countries.table_titles.reward_amount_of_new_user')"
                    :error="CountryObj.errors.has('reward_amount_of_new_user')"
                    :error-message="CountryObj.errors.get('reward_amount_of_new_user')"
                    color="primary"
                >
                    <template v-slot:prepend>
                        <small>{{ CountryObj.currency_acronym }}</small>
                    </template>
                </q-input>
            </div>  <!-- Reward Amount Of New User -->
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="CountryObj.reward_amount_of_old_user"
                    type="Number"
                    :label="$t('countries.table_titles.reward_amount_of_old_user')"
                    :error="CountryObj.errors.has('reward_amount_of_old_user')"
                    :error-message="CountryObj.errors.get('reward_amount_of_old_user')"
                    color="primary"
                >
                    <template v-slot:prepend>
                        <small>{{ CountryObj.currency_acronym }}</small>
                    </template>
                </q-input>
            </div>  <!-- Reward Amount Of Old User -->
            <div class="col col-xs-12 col-md-6 col-lg-6">
                <q-input
                    v-model="CountryObj.reward_min_transfer_amount"
                    type="Number"
                    :label="$t('countries.table_titles.reward_min_transfer_amount')"
                    :error="CountryObj.errors.has('reward_min_transfer_amount')"
                    :error-message="CountryObj.errors.get('reward_min_transfer_amount')"
                    color="primary"
                >
                    <template v-slot:prepend>
                        <small>{{ CountryObj.currency_acronym }}</small>
                    </template>
                </q-input>
            </div>  <!-- Reward Min Transfer Amount -->
            <div class="col col-xs-12 col-sm-6 col-md-4">
                <p class="text-caption q-pb-xs" style="margin:0">Country is used as a secondary currency</p>
                <q-toggle
                    v-model="CountryObj.is_for_secondary_currency"
                    color="negative"
                    :label="CountryObj.is_for_secondary_currency ? 'Yes' : 'No'"
                />
            </div> <!-- IS FOR SECONDARY CURRENCY -->
            <div class="col col-xs-12 col-sm-6 col-md-4">
                <p class="text-caption q-pb-xs" style="margin:0">ID document accepted</p>
                <q-toggle
                    v-model="CountryObj.has_acceptable_id_document"
                    color="negative"
                    :label="CountryObj.has_acceptable_id_document ? 'Yes' : 'No'"
                />
            </div> <!-- HAS ACCEPTABLE ID DOCUMENT -->
        </div>
    </form>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
    name: 'Form',
    model: {
        prop: 'CountryObj',
        event: 'change'
    },
    props: {
        CountryObj: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters(['rebit_accounts', 'currencies','exchange_rates_loading']),
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        ...mapActions(['set_currencies']),
        submit() {
            this.$emit('submit')
        },
    },
    created(){
        if (! this.currencies.length) {
            this.loading = true
            this.set_currencies().then(() => {this.loading = false}).catch(() => {this.loading = false})
        }
    },
    components: {},
}
</script>

<style scoped>

</style>
